// removed by extract-text-webpack-plugin
module.exports = {"graphic":"Password__graphic___2QL2A","lettering":"Password__lettering___2ViR_","h3":"Password__h3___10GT6"};


//////////////////
// WEBPACK FOOTER
// ./study_reviewer/src/components/passwordReset/Password.css
// module id = 1212
// module chunks = 0